import { render, staticRenderFns } from "./PostRoute.vue?vue&type=template&id=31750f10&scoped=true&"
import script from "./PostRoute.vue?vue&type=script&lang=js&"
export * from "./PostRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31750f10",
  null
  
)

export default component.exports